import { useImg } from '@/common/jsBridge.api'
export const uploadImg = async (multiple: boolean) => {
  const resp = await useImg({ multiple }) as { pic: string }
  return resp.pic
}
